<script>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    group: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.initFancybox();
  },
  beforeUnmount() {
    this.destroyFancybox();
  },
  methods: {
    initFancybox() {
      if (this.$refs.container) {
        Fancybox.bind(`[data-fancybox="${this.group}"]`, {
          ...(this.options || {}),
          dragToClose: false,
          Toolbar: {
            display: {
              left: ['close'],
              middle: [],
              right: [],
            },
          },
          Images: {
            zoom: false,
          },
          Thumbs: {
            type: 'classic',
          },
          Carousel: {
            transition: false,
            friction: 0,
          },
          on: {
            'Carousel.ready Carousel.change': (fancybox) => {
              fancybox.container.style.setProperty(
                '--bg-image',
                `url("${fancybox.getSlide().thumbSrc}")`
              );
            },
          },
        });
      }
    },
    destroyFancybox() {
      if (this.$refs.container) {
        Fancybox.destroy();
      }
    },
  },
};
</script>

<template>
  <div ref="container">
    <slot></slot>
  </div>
</template>
